import R from 'app/assets/R'
import { PermissionEnum } from 'app/common/enum'
import { BaseCol } from 'app/components/common/BaseCol'
import { BaseSpace } from 'app/components/common/BaseSpace'
import BaseText from 'app/components/common/BaseText'
import { SectionBase } from 'app/components/common/SectionBase'
import HeaderPage from 'app/components/header/components/HeaderPage'
import { BaseTableManagement } from 'app/components/tables/BaseTableManagement'
import { useVerifyPermission } from 'app/helpers/permission.helper'
import React, { useEffect, useMemo } from 'react'
import { useHook } from './hook'
import { CreateModalLayout, FilterLayout } from './layouts'
import * as S from './styles'

const UnitManagementContainer: React.FC = () => {
  const { filter, onChangeFilter, downloadExcel,  columns, dataTable, handleTableChange, isLoading, pagination } = useHook()

  const { user, verifyPermissionAndRedirect, verifyPermission } =
    useVerifyPermission()

  useEffect(() => {
    verifyPermissionAndRedirect(PermissionEnum.ReadUnit)
  }, [user])

  const isCreateUnit = useMemo(() => {
    return verifyPermission(PermissionEnum.CreateUnit)
  }, [user])

  return (
    <S.ScrollWrapper>
      <HeaderPage
        titleI18nKey={R.strings.unit_management}
        rightComponent={
          <>
            {isCreateUnit ? (
              <BaseCol>
                <CreateModalLayout />
              </BaseCol>
            ) : null}
          </>
        }
        isExport={verifyPermission(PermissionEnum.ExportUnit)}
        onPressExport={downloadExcel}
      />

      <SectionBase>
        <BaseSpace>
          <FilterLayout filter={filter} onChangeFilter={onChangeFilter} />

          <BaseTableManagement
            pagination={{
              ...pagination,
              total: pagination.total,
              showTotal: total => (
                <BaseText children={`Tổng: ${total}`} fontWeight="bold" />
              ),
              showSizeChanger: true,
            }}
            columns={columns}
            dataSource={dataTable}
            onChange={handleTableChange}
            loading={isLoading}
            scroll={{ x: true }}
          />
        </BaseSpace>
      </SectionBase>
    </S.ScrollWrapper>
  )
}

export default UnitManagementContainer
